<template>
    <div class="h-full h">
        <Head :title="__(title)" />
        <h2 class="text pt-8 px-6 pb-4 text-[20px] font-medium">YOUR WORKSPACES</h2>
        <hr class="mx-6">
        <div class="flex workspace__view flex-col task__table overflow-hidden overflow-y-auto">
            <div v-for="(workspace, workspace_index) in workspaces" class="min-w-full py-4 align-middle md:px-3 lg:px-4">
                <div class="flex items-center justify-between w-full">
                    <div class="flex items-center gap-2">
                        <div class="flex items-center font-bold text-[20px] justify-center w-[32px] h-[32px] rounded bg-indigo-500 text-white">H</div>
                        <h2 class="text mb-4 px-2 mt-4 text-[20px] font-medium">{{ workspace.name }}</h2>
                    </div>
                    <div class="flex gap-3">
                        <Link :href="route('workspace.view', workspace.id)" class="flex gap-2 items-center rounded bg-gray-200 hover:bg-gray-300 px-3 py-2 text-xs focus:outline-none font-bold focus:ring-0"> <icon name="board" class="w-4 h-4"/> Boards</Link>
                        <button class="flex gap-2 items-center rounded bg-gray-200 hover:bg-gray-300 px-3 py-2 text-xs focus:outline-none font-bold focus:ring-0"> <icon name="user" class="w-4 h-4"/> Members ({{ workspace.members?.length }})</button>
                    </div>
                </div>

                <create-project v-if="create_project" @create-project="create_project = false" />

                <ul class="project__list">
                    <li class="w-full py-1 px-2" v-if="!!this.$page.props.auth.user.role.create_project">
                        <button @click="create_project = true" class="p-2 group flex w-full rounded justify-between bg-cover bg-[#091e420f] hover:bg-[#091e4224]">
                            <div class="flex flex-col h-24 w-full justify-center text-[16px] font-bold text-[#172b4d]">
                                Create new project
                            </div>
                        </button>
                    </li>
                    <li v-for="(project, project_index) in workspace.projects" class="w-full py-1 px-2">
                        <Link :href="route('projects.view.board', project.slug || project.id)" :style="{background: 'url('+project.background?.image+')'}" class="p__item group">
                            <div class="content">
                                <div class="element">
                                    <div class="title">{{ project.title }}</div>
                                    <p class="details">{{ getDetails(project.description) }}</p>
                                </div>
                                <button class="flex w-7 h-7 items-center justify-center" @click="saveProject($event, project)">
                                    <icon v-if="!!project.star" name="star" class="w-5 h-5 fill-yellow-500 text-yellow-500 hover:fill-none hover:scale-125" />
                                    <icon v-else name="star" class="w-5 h-5 opacity-0 text-white group-hover:opacity-100 hover:text-yellow-500 hover:scale-125" />
                                </button>
                            </div>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import BoardViewMenu from '@/Shared/BoardViewMenu'
import moment from 'moment'
import SearchInput from '@/Shared/SearchInput'
import CreateProject from "@/Shared/Modals/CreateProject";
import InviteWorkspaceMember from "../../Shared/Modals/InviteWorkspaceMember";
import axios from 'axios'
import DeleteConfirmation from "../../Shared/DeleteConfirmation";


export default {
    components: {
        DeleteConfirmation,
        InviteWorkspaceMember,
        CreateProject,
        Head,
        Icon,
        Link,
        BoardViewMenu,
        Pagination,
        SearchInput,
    },
    layout: Layout,
    props: {
        title: String,
        auth: Object,
        workspaces: Object,
        filters: Object,
    },
    data() {
        return {
            create_project: false,
            delete_workspace_popup: false,
            edit_workspace_option: false,
            invite_workspace: false,
            show_more: false,
            form: {
                search: '',
            },
        }
    },
    computed: {

    },
    created() {
        this.moment = moment
    },
    methods: {
        getDetails(text){
            if(text && text.length > 50)text = text.substring(0,50)+'...';
            return text;
        },
        deleteWorkspace(){
            this.$inertia.delete(this.route('workspace.destroy', this.workspace.id))
        },
        closeInviteMember(){
            this.invite_workspace = false
            window.location.href = this.route('workspace.members',this.workspace.slug || this.workspace.id);
        },
        updateWorkspace(){
            const data = {name: this.workspace.name, website: this.workspace.website, description: this.workspace.description};
            axios.post(this.route('json.workspace.update', this.workspace.id), data);
            this.edit_workspace_option = false;
        },
        saveProject(e, project){
            project.star = !project.star;
            e.preventDefault();
            axios.post(this.route('json.p.starred.save', project.id)).then((resp) => {
                // this.getProjects();
            });
        },
    },
}
</script>
